import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ToastContext from "../../../contexts/toast";
import { RichiestaService } from "../../../services/RichiestaService";
import AlertMessage from "../../Utility/Alert/AlertMessage";
import { FormUtility } from "../../Utility/FormUtility";
import Input from "../../Form/Input";
import InputIban from "../../Form/InputIban";
import Checkbox from "../../Form/Checkbox";
import Modal from "../../Utility/Modal/Modal";

const RettificaIban = (props) => {
  const formRef = useRef(null);
  const navigate = useNavigate();
  const [dirty, setDirty] = useState(false);
  const toastContext = useContext(ToastContext);
  const [errorIban, setErrorIban] = useState(false);

  const [showError, setShowError] = useState(false);

  const [inputErrors, setInputErrors] = useState([]);

  const [iban, setIban] = useState('');
  const [nomeBanca, setNomeBanca] = useState('');

  const [informativa1, setInformativa1] = useState(false);
  const [informativa2, setInformativa2] = useState(false);
  const [validate, setValidate] = useState(false);
  
  const richiestaService = new RichiestaService();

  const utility = new FormUtility();

  const location = useLocation();
  const { richiestaId } = location.state || {};

  const [isModalOpen, setModalOpen] = useState(false);
  const [title, setTitle] = useState(null);
  const [content, setContent] = useState(null);
  const [icon, setIcon] = useState(false);
  const [hideCloseButton, setHideCloseButton] = useState(false);
  const [actionLabel, setActionLabel] = useState(false);
  const [iconaClass, setIconaClass] = useState(null);
  const [iconaColorClass, setIconaColorClass] = useState(null);


  const onChangeIban = (param)=>{
    setDirty(true);
    
    return validazioneIBANItaliano(param);
  }

  const validazioneIBANItaliano = (param) => {
    setErrorIban(false);
    const ibanToCheck = param;
    let iban = param;
    iban = iban.replace(/\s/g, '').toUpperCase();
    const lunghezza = iban.length;
    const codicePaese = iban.substring(0, 2);

    if (codicePaese !== "IT") {
        setErrorIban(true);
        setIban(ibanToCheck);
        return false;
    }

    if (lunghezza !== 27) {
        setErrorIban(true);
        setIban(ibanToCheck);
        return false;
    }

    const cifreControllo = iban.substring(2, 4);
    const contoBase = iban.substring(4);
    let numeroRiorganizzato = contoBase + codicePaese + cifreControllo;
    numeroRiorganizzato = numeroRiorganizzato.replace(/[A-Z]/g, (lettera) => {
        return parseInt(lettera, 36);
    });

    let resto = numeroRiorganizzato;
    let blocco;
    while (resto.length > 2) {
        blocco = resto.substring(0, Math.min(9, resto.length));
        resto = parseInt(blocco, 10) % 97 + resto.substring(blocco.length);
    }
    const isValid = parseInt(resto, 10) % 97 === 1;
    setErrorIban(!isValid);

    setIban(ibanToCheck);

    return isValid;
  };

  useEffect(() => {
    init();
  }, []);

  const init = async() => {
    const r = await richiestaService.get(richiestaId);
    const datiPagamento = r.richiestaDatiPagamento;
    const oldIban = datiPagamento.iban;
    const nomeBanca = datiPagamento.denominazioneBanca;
    validazioneIBANItaliano(oldIban)
    setNomeBanca(nomeBanca);
  }

  const map = {
    informativa1: setInformativa1,
    informativa2: setInformativa2
  };

  const onChangeValueCheckBox = (event) => {
    const target = event.target;
    const set = map[target.name];
    set(target.checked === true);
    if (validate) {
      setFormErrors(false);
    }
  };

  const setFormErrors = (setFocus = true) => {
    const errors = utility.getAllInputErrors(formRef);
    setInputErrors(errors.map((el) => el.id));
    if (setFocus && errors.length > 0) {
      errors[0].focus();
    }
  };

  const handleInitialSubmit = (event) => {
    event.preventDefault();
    setShowError(true);
    setValidate(true);

    const isIbanValid = validazioneIBANItaliano(iban);
    const htmlValidationErrors = utility.getAllInputErrors(formRef);

    const isValidForm = iban && isIbanValid && nomeBanca && informativa1 && informativa2;

    if (!isValidForm || htmlValidationErrors.length > 0) {
      toastContext.error("Compila tutti i campi obbligatori e correggi gli errori.");
      setFormErrors(true);
      return;
    }


    setModalOpen(true);
    setIcon(true);
    setActionLabel("Conferma");
    setTitle("Attenzione");
    setIconaClass("solid--exclamation-triangle");
    setIconaColorClass("rtds-text-warn-dark");
    setHideCloseButton(false);
    if (dirty) {
      setContent("Attenzione! Proseguire con l'aggiornamento della domanda?");
    } else {
      setContent(
        "Attenzione! Non è stato modificato alcun dato, proseguire con l'aggiornamento della domanda?"
      );
    }
  };


  const confirmAndSubmit = async () => {
    setModalOpen(false);

    console.log("Form valido, procedo con l'invio");

    const body = {
      iban,
      nomeBanca
    }

    try {
      await richiestaService.rettificaIban(
        richiestaId,
        body
      );
      toastContext.success("Rettifica IBAN inoltrata con successo!");
      navigate('/dashboard');
    } catch (error) {
      toastContext.error("Si è verificato un errore durante l'inoltro della rettifica.");
      console.error("Submission error:", error);
    }
  };

  if (!richiestaId) {
    return (
      <div className="rtds-my-12">
        <div className="rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02">
          <p className="rtds-text-red-600 rtds-font-bold">
            Impossibile caricare i dati di rettifica IBAN.
          </p>
        </div>
      </div>
    );
  }


  return (
<>
<div className="rtds-container rtds-my-12">
  
    <div className=" rtds-my-12 ">
      <div className="rtds-mb-6 ">
        <h1 className="rtds-text-2xl rtds-font-bold">Dati di pagamento</h1>
      </div>
      <div className="rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02">
        <div className="rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02">
          <p>
            I campi obbligatori sono contrassegnati da un asterisco&nbsp;
            <abbr
              className="rtds-font-bold rtds-no-underline"
              title="obbligatorio"
            >
              *
            </abbr>
          </p>
        </div>

        <form
          noValidate
          onSubmit={handleInitialSubmit}
          ref={formRef}
          id="hasValidationForm"
          className="has-js-validation-form rtds-py-6 rtds-space-y-4"
        >

          <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

          <h2 className="rtds-text-xl rtds-font-bold">Dati di pagamento</h2>
          <p>
            Indicare il codice IBAN del conto su cui si desidera ricevere il
            contributo.{" "}
          </p>

          <AlertMessage 
            iconName="mini--information-circle"
            title="Attenzione!"
            message="L’IBAN deve essere intestato, o cointestato, al soggetto richiedente che sta presentando la domanda di accesso alla misura Libri Gratis."
          />

          <div className={`rtds-field-row relative`} >
            <InputIban
              label={"IBAN"}
              id={"iban"}
              classInput={"rtds-text-sm rtds-input-placeholder rtds-uppercase"}
              type={"text"}
              onChange={(event) => onChangeIban(event.target.value)}
              value={iban}
              required
              maxLength={27}
              minLength={27}
              classDiv={`${!showError || !errorIban ? '' : 'has-error'}`}
              errorIban={showError && errorIban}
              errorMessage={"Iban non valido"}

            />
              
            <Input
              label={"Nome banca"}
              id={"denominazione"}
              inputErrors={inputErrors}
              classInput={"rtds-text-sm rtds-input-placeholder"}
              type={"text"}
              onChange={(event) => {setNomeBanca(event.target.value); setDirty(true);}}
              value={nomeBanca || ""}
              required={true}
              maxLength={255}
            />
          </div>

          <span hidden={!showError || !errorIban} className="rtds-input-field__error">Iban non valido</span>
                <div className="rtds-mb-6">
                  <fieldset className="rtds-input-field rtds-gap-2">
                    <legend className="rtds-input-field__label">
                      {"Dichiaro: "}
                    </legend>

                    <Checkbox
                      classDiv={"rtds-input-checkbox rtds-input--lg"}
                      id={"informativa1"}
                      classLabel={"rtds-mr-8"}
                      label={
                        "di essere consapevole che, nel caso di ottenimento del contributo, possono essere eseguiti controlli, anche da parte della Guardia di Finanza, in applicazione dell'art.  4, commi  2  e  8,  del  D.Lgs.  n.109  del  31 marzo  1998,  in materia di controllo della veridicità delle informazioni fornite; "
                      }
                      inputErrors={inputErrors}
                      onChange={onChangeValueCheckBox}
                      checked={
                    informativa1 ||
                   /* richiesta?.statoRichiesta == "AGGIORNATA" ||*/
                    false
                  }
                      required={/*richiesta?.statoRichiesta === "PRESENTATA"*/true}
                    />

                    <Checkbox
                      classDiv={"rtds-input-checkbox rtds-input--lg"}
                      classLabel={"rtds-mr-8"}
                      id={"informativa2"}
                      label={
                        "di essere consapevole delle sanzioni penali nel caso di dichiarazioni non veritiere, di formazione o uso di atti falsi, richiamate dall'art. 76 del D.P.R. 28.12.2000, n. 445;"
                      }
                      inputErrors={inputErrors}
                      onChange={onChangeValueCheckBox}
                      checked={
                    informativa2 ||
                    /*richiesta?.statoRichiesta == "AGGIORNATA" ||*/
                    false
                  }
                    required={/*richiesta?.statoRichiesta === "PRESENTATA"*/ true}
                    />
                  </fieldset>
                  {/* <h2 className="rtds-text-lg rtds-font-bold">Dichiaro:</h2> */}
                </div>

          <AlertMessage 
          iconName="mini--information-circle"
          title="Attenzione!"
          message="Verificare tutti i dati inseriti prima di inoltrare la rettifica"
          >

          </AlertMessage>
          <div className="rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center">
            <div className="rtds-form-actions">
              <div
                className="rtds-inline-flex rtds-gap-1"
                role="group"
                aria-label="Ruolo"
              >
                <button
                  type="submit"
                  className="rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-right rtds-group/button"
                >
                  Inoltra rettifica
                  {false ? (
                    <>
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-animate-spin md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`} />
                      </svg>
                      <span className="rtds-sr-only">Caricamento...</span>
                    </>
                  ) : (
                    <>
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                        />
                      </svg>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <Modal
      isOpen={isModalOpen}
      title={title}
      content={content}
      onAction={confirmAndSubmit}
      actionLabel={actionLabel}
      closeLabel="Annulla"
      hideCloseButton={hideCloseButton}
      icona={icon}
      iconaClass={iconaClass}
      iconaColorClass={iconaColorClass}
      onClose={() => setModalOpen(false)}

      //disabledConfirmBtn={inSave}
      //disableCloseBtn={inSave}
    />
</div>
</>
  );
};

export default RettificaIban;

